/**
 * Date Formatting Utilities
 *
 * Shared date formatting functions used across the application.
 */

/**
 * Format version date for display (YYYY-MM-dd HH:MM) in local timezone.
 * Handles UTC date strings from backend by appending 'Z' if no timezone specified.
 *
 * @param dateString - ISO 8601 date string from backend (e.g., "2026-02-23T09:08:00")
 * @returns Formatted date string in local timezone
 */
export function formatVersionDate(dateString: string): string {
  // Ensure the date string is treated as UTC if no timezone is specified
  // Backend returns ISO 8601 format like "2026-02-23T09:08:00" which needs 'Z' suffix
  let normalizedDateString = dateString;

  // If no timezone indicator (Z or +), append Z to treat as UTC
  if (
    !dateString.includes('Z') &&
    !dateString.includes('+') &&
    !dateString.includes('-', dateString.indexOf('T') + 1)
  ) {
    // Handle both "YYYY-MM-DD HH:MM:SS" and "YYYY-MM-DDTHH:MM:SS" formats
    normalizedDateString = dateString.includes('T')
      ? dateString + 'Z'
      : dateString.replace(' ', 'T') + 'Z';
  }

  const date = new Date(normalizedDateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}`;
}
